module.exports = __webpack_public_path__ + "static/media/round-triangle-blue.9e4c27b2.svg";